import React, { useEffect, useRef, useState } from "react";
import _ from 'lodash'
import { addTimeslotsOccupied } from "services/redux/data/actions";
import { useDispatch, useSelector } from "react-redux";
import { dataConstants } from "services/redux/data/constants";
import HelperString from "utils/helper-string";
import FetchBooking from "utils/fetch/FetchBooking";
import FetchTimeslotCapacity from "utils/fetch/FetchTimeslotCapacity";
import { PlaceholderCalendarStrip } from "placeholders";
import ObjectBooking from "utils/objects/booking";
import ThemedCalendarStrip from "components/atoms/ThemedCalendarStrip";
import FetchError from "components/molecules/FetchError";
import ReactTimeout from 'react-timeout'
import { useIsFocused } from '@react-navigation/native'
import selectBookings from 'services/redux/data/selectors/selectBookings'
import HelperLocaleSettings from 'utils/helper/HelperLocaleSettings'
import { localeSettingConstants } from 'utils/constants/LocaleSettings'
import HelperDate, { dateFormat } from 'utils/helper-date'

const IndexCalendarSceneBlock = ({ date, onSelectDate, setTimeout, clearTimeout }) => {
	const _employee = useSelector( state => {
		return state.data[dataConstants.EMPLOYEE];
	} );
	
	const isFocused = useIsFocused();
	const fetchTimeout = useRef();
	const dispatch = useDispatch()
	
	const _bookings = useSelector( selectBookings )
	
	const [ loading, setLoading ] = useState( true )
	const [ error, setError ] = useState( false )
	const [ calendarKey ] = useState( HelperString.random() )
	const [ selectedDate, setSelectedDate ] = useState( date );
	
	const getBookingsByDay = ( date ) => {
		const dayBookings = _.filter( _bookings, {
			'booking_date': date.format( dateFormat.DATE )
		});
		
		return ObjectBooking.filterAccepted( dayBookings );
	}
	
	const onSelectDateChange = ( nextDate ) => {
		onSelectDate( nextDate );
		
		setError( false )
		
		fetchTimeslotCapacity({
			bookings: getBookingsByDay( nextDate ),
			callbackSuccess: () => {
				setLoading( false )
			},
			callbackError: () => {
				setLoading( false )
				setError( true )
			}
		});
		
	};
	
	const onModeChange = ( mode ) => {
		HelperLocaleSettings.set( localeSettingConstants.CALENDAR_VIEW_MODE_BOOKINGS, mode );
	}
	
	const onErrorAction = () => {
		setLoading( true )
		FetchBooking.resetMonthsFetched();
		
		onSelectDateChange( HelperDate.date() );
	}
	
	const fetchTimeslotCapacityTimeout = () => {
		clearTimeout( fetchTimeout.current )
		
		fetchTimeout.current = setTimeout( fetchTimeslotCapacity, 25000 );
	}
	
	const fetchTimeslotCapacity = ( { bookings = null, callbackSuccess = null, callbackError = null } = {} ) => {
		const fetchBookings = bookings ?? [];
		
		FetchTimeslotCapacity.fetchByBookings( fetchBookings, {
			callbackStart: () => {
				clearTimeout( fetchTimeout.current )
			},
			callbackSuccess: result => {
				dispatch( addTimeslotsOccupied( result ) )
				
				fetchTimeslotCapacityTimeout();
				
				if( _.isFunction( callbackSuccess ) ) {
					callbackSuccess();
				}
			},
			callbackError: result => {
				fetchTimeslotCapacityTimeout();
				
				if( _.isFunction( callbackError ) ) {
					callbackError();
				}
			}
		});
	};
	
	useEffect( () => {
		if( date.isSame( selectedDate, 'day' ) === false ) {
			setSelectedDate( date );
		}
	}, [ date ] );
	
	useEffect( () => {
		FetchBooking.resetMonthsFetched();
		setLoading( false )
	}, [] );
	
	// Set or clear timeout when focus changes
	useEffect( () => {
		if( !isFocused ) {
			clearTimeout( fetchTimeout.current )
		} else {
			fetchTimeslotCapacity();
		}
	}, [ isFocused ] )
	
	if( loading ) {
		return (
			<PlaceholderCalendarStrip />
		)
	}
	
	if( error ) {
		return (
			<FetchError
				action={ onErrorAction }
			/>
		)
	}
	
	return (
		<ThemedCalendarStrip
			stacked
			key={ HelperString.hash( 'calendar-strip', calendarKey ) }
			refresh={ calendarKey }
			onSelect={ onSelectDateChange.bind( this ) }
			onModeChange={ onModeChange.bind( this ) }
			employee={ _employee }
			date={ selectedDate }
			showQrCode={ HelperDate.fn.isToday( selectedDate ) }
		/>
	)
}

export default ReactTimeout( IndexCalendarSceneBlock )
